import {
  gradesConstantsCL,
  gradesConstantsMX,
  gradesConstantsPE,
  gradesConstantsCOL,
  gradesConstantsUSA,
  gradesConstantsBR
} from '@BUP/constants'
import { COURSE_ASSIGNMENT_MANAGERS } from '@BUP/configs/courseAssignmentAccess'

export const isModeBup = organization => {
  return !!(organization && organization.mode_bup)
}

// TODO: check and remove this function, apparently it's not used
// export const isFreemiun = organization => {
//   return !!(organization && organization?.freemium)
// }

export const isData = organization => {
  return !!(organization && organization.data)
}

export const isWebinars = organization => {
  return !!(organization && organization.webinar)
}

export const isSociogram = organization => {
  return !!(organization && organization.sociogram)
}

export const hasCourseAssignmentEnabled = organization => {
  return !!(organization && organization.courseAssignment)
}

const normalizeEmail = email => (email || '').trim().toLowerCase()

// Whether this user can see the course-assignment configuration pages. Organizations without an
// allowlist in COURSE_ASSIGNMENT_MANAGERS are unrestricted; listed ones only allow those emails.
export const canManageCourseAssignment = (organization, user, managers = COURSE_ASSIGNMENT_MANAGERS) => {
  const allowedEmails = organization && managers[organization.id]
  if (!allowedEmails) return true
  const userEmail = normalizeEmail(user?.email)
  return !!userEmail && allowedEmails.some(email => normalizeEmail(email) === userEmail)
}

export const hasRecommendationsEnabled = organization => {
  return !!(organization && organization.recommendation)
}

export const hasLogbookEnabled = organization => {
  return !!(organization && organization.logbook)
}

export const hasMetricsDashboardEnabled = organization => {
  return !!(organization && organization.showMetricsDashboard)
}

// TODO: check and remove this function, apparently it's not used
// export const isModeBupCaseOpen = comment => {
//   const caseState = comment?.state
//   if (!caseState) return false
//   return caseState === COMMENT_OPEN ? true : caseState !== COMMENT_CLOSED
// }

// TODO: check and remove this function, apparently it's not used
// export const isRoleAllowed = (userRole, roles) => {
//   return roles && roles.length ? !!roles.includes(userRole) : false
// }

export const handleSchoolgrades = locale => {
  switch (locale) {
    case 'es-CL':
      return gradesConstantsCL
    case 'es-MX':
      return gradesConstantsMX
    case 'es-CO':
      return gradesConstantsCOL
    case 'es-PE':
      return gradesConstantsPE
    case 'pt-BR':
      return gradesConstantsBR
    case 'en-US':
      return gradesConstantsUSA
    default:
      return []
  }
}

export const findNivel = (lang, course) => {
  if (!lang || !course) {
    throw new TypeError('findNivel requires lang and course')
  }
  if (!Array.isArray(course.tags)) {
    return undefined
  }
  const grades = handleSchoolgrades(lang)
  const nivel = course.tags.find(tag => tag.includes('nivel'))
  const filterNivel = grades.find(elem => elem.id === nivel)
  return filterNivel
}
